import { connect } from 'react-redux';
import { updateCategory, createCategory } from 'shared/store/actions/admission.actions';
import { AdmissionCategoryEditorComponent } from './admission-category-editor.component';

const mapStateToProps = ({ application, admission }, { entity }) => ({
  adminMode: application.adminMode,
});

const mapDispatchToProps = {
  createCategory,
  updateCategory,
};

export const AdmissionCategoryEditor = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdmissionCategoryEditorComponent);
